/**
 * @desc old name shortStrPipe
 * @param identification
 */
var maskName = function (identification) {
    if (identification) {
        identification = identification.toString();
        return "".concat(identification.charAt(0), "****").concat(identification.charAt(identification.length - 1));
    }
    console.warn("PLEASE PROVIDE VALID ARGUMENT - maskName function, current argument - ".concat(identification));
    return identification;
};

export { maskName };
